var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6022 79.0126C50.6253 79.0126 63.6146 66.0233 63.6146 50.0002C63.6146 33.9771 50.6253 20.9878 34.6022 20.9878C18.5791 20.9878 5.58984 33.9771 5.58984 50.0002C5.58984 66.0233 18.5791 79.0126 34.6022 79.0126Z",
    fill: "#1B1E36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7072 6.37744C29.31 6.37744 24.9336 25.9534 24.9336 50.1018C24.9336 74.2502 29.31 93.8262 34.7072 93.8262C40.1044 93.8262 44.4808 74.2502 44.4808 50.1018C44.4808 25.9534 40.1044 6.37744 34.7072 6.37744ZM35.382 91.3587C34.7648 92.1818 34.1476 91.5642 34.1476 91.5642C31.662 88.6842 30.4192 83.3338 30.4192 83.3338C26.0716 69.3422 27.1064 39.301 27.1064 39.301C29.1496 15.4514 32.8664 9.81744 34.1312 8.56664C34.2604 8.43898 34.4304 8.36097 34.6114 8.34634C34.7924 8.33171 34.9728 8.38139 35.1208 8.48664C36.956 9.78704 38.4952 15.2254 38.4952 15.2254C43.0404 32.0978 42.6288 47.9414 42.6288 47.9414C43.0404 61.7274 40.3512 77.1594 40.3512 77.1594C38.2812 88.8875 35.382 91.3587 35.382 91.3587Z",
    fill: "#6F7390"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6245 55.142C37.4654 55.142 39.7685 52.839 39.7685 49.998C39.7685 47.1571 37.4654 44.854 34.6245 44.854C31.7835 44.854 29.4805 47.1571 29.4805 49.998C29.4805 52.839 31.7835 55.142 34.6245 55.142Z",
    fill: "#B7B9C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.718 33.332C57.3658 33.332 58.7016 31.9502 58.7016 30.2456C58.7016 28.541 57.3658 27.1592 55.718 27.1592C54.0702 27.1592 52.7344 28.541 52.7344 30.2456C52.7344 31.9502 54.0702 33.332 55.718 33.332Z",
    fill: "#B7B9C8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7375 43.8276C8.3853 43.8276 9.72111 42.4458 9.72111 40.7412C9.72111 39.0366 8.3853 37.6548 6.7375 37.6548C5.08971 37.6548 3.75391 39.0366 3.75391 40.7412C3.75391 42.4458 5.08971 43.8276 6.7375 43.8276Z",
    fill: "#B7B9C8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5578 81.687C30.2056 81.687 31.5414 80.3051 31.5414 78.6006C31.5414 76.896 30.2056 75.5142 28.5578 75.5142C26.91 75.5142 25.5742 76.896 25.5742 78.6006C25.5742 80.3051 26.91 81.687 28.5578 81.687Z",
    fill: "#B7B9C8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#627EEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5625 12.5V40.2188L74.9906 50.6875L51.5625 12.5Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5562 12.5L28.125 50.6875L51.5562 40.2188V12.5Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5625 68.6523V87.4866L75.0063 55.0522L51.5625 68.6523Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5562 87.4866V68.6491L28.125 55.0522L51.5562 87.4866Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5625 64.2917L74.9906 50.6886L51.5625 40.2261V64.2917Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 50.6886L51.5562 64.2917V40.2261L28.125 50.6886Z",
    fill: "white",
    fillOpacity: 0.602
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.4c71e875c46225ec64b8656995906427.svg";
export { ForwardRef as ReactComponent };